/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { PageHero } from "../components/subcomponents/PageHero";
import bigCover from "../assets/images/big-cover.jpg";
import { apiGet } from "../utils/api";
import { Colors } from "../utils/utils.colors";
import { routes } from "../utils/utils.routes";
import { PageSkeleton } from "../components/PageSkeleton";
import { FaGraduationCap, FaCertificate } from "react-icons/fa";
import { useLanguage } from "../contexts/LanguageContext";
import { pickLocalized } from "../utils/locale";
import { PageSectionHeader } from "../components/subcomponents/PageSectionHeader";

const isOnlineCourse = (c: any) => {
  const cat = (c.category || "").toLowerCase();
  return cat.includes("cours") || cat.includes("course") || cat.includes("mooc") || cat.includes("e-learning");
};

const GradI = FaGraduationCap as any;
const CertI = FaCertificate as any;

export const FacultyDetail: React.FC = () => {
  const { slug } = useParams<{ slug: string }>();
  const { lang, t } = useLanguage();
  const [faculty, setFaculty] = useState<any>(null);
  const [contents, setContents] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!slug) return;
    apiGet(`/faculties/${slug}`)
      .then(async (d) => {
        setFaculty(d.item);
        const list = await apiGet("/contents", { facultyId: d.item.id, limit: 50 });
        setContents(list.rows);
      })
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <PageSkeleton />;
  if (!faculty) {
    return (
      <div className="faculty-page" style={{ padding: 80, textAlign: "center" }}>
        <h2>{t.faculty.notFound}</h2>
        <Link to={routes.FACULTIES} style={{ color: Colors.primaryColor, fontWeight: 600 }}>← {t.faculty.allFaculties}</Link>
      </div>
    );
  }

  const name = pickLocalized(faculty, "name", lang);
  const domaine = pickLocalized(faculty, "domaine", lang);
  const description = pickLocalized(faculty, "description", lang);
  const dean = pickLocalized(faculty, "dean", lang);
  const secretary = pickLocalized(faculty, "secretary", lang);
  const cover = faculty.coverImage || bigCover;

  return (
    <>
      <PageHero
        imageCover={cover}
        eyebrow={domaine}
        title={name}
        tall
        breadcrumbs={[
          { label: t.faculty.allFaculties, href: routes.FACULTIES },
          { label: name },
        ]}
      />
      <div className="wp-block-group padding-x is-layout-constrained faculty-page">
        <div className="faculty-detail-layout">
          <div>
            <section style={{ marginBottom: 40 }}>
              {faculty.coverImage && (
                <img src={cover} className="mb-4" style={{ borderRadius: 10 }} />
              )}
              <PageSectionHeader
                id="faculties-item"
                eyebrow={"Présentation"}
                title={t.faculty.presentation}
                lead={
                  <>
                    {description ? (
                      <div className="rich-content" dangerouslySetInnerHTML={{ __html: description }} />
                    ) : (
                      <p style={{ color: "#888" }}>—</p>
                    )}
                  </>
                }
                align="start"
              />
            </section>

            <section>
              <h3 style={{ color: Colors.primaryColor, fontSize: 22, fontWeight: 700, marginBottom: 18 }}></h3>
              <PageSectionHeader
                id="faculties-item-programme"
                eyebrow={"Programme"}
                title={t.faculty.programs}
                lead={
                  <>
                    Au-delà de ses filières régulières, une faculté peut toutefois organiser des programmes de formation en spécialisation.
                    Ces cursus spécifiques visent à approfondir des compétences pointues et adaptées au marché du travail.
                    L'accès à ces options dépend des critères d'admission propres à chaque département.
                    Pour découvrir l'ensemble de nos offres, veuillez consulter notre catalogue ou contacter le secrétariat.
                  </>
                }
                align="start"
              />
              <div data-testid="filieres-list" style={{ display: "grid", gap: 14 }}>
                {(faculty.filieres || []).map((f: any) => (
                  <div key={f.id} data-testid={`filiere-${f.slug}`} className="faculty-program-card">
                    <h4 style={{ color: Colors.darkColor, fontSize: 17, marginBottom: 8, display: "flex", alignItems: "center", gap: 10 }}>
                      <GradI color={Colors.primaryColor} /> {pickLocalized(f, "name", lang)}
                    </h4>
                    {pickLocalized(f, "description", lang) && (
                      <p style={{ color: "#5c6b7a", marginBottom: 12, lineHeight: 1.6 }}>{pickLocalized(f, "description", lang)}</p>
                    )}
                    <div className="col-lg-6" style={{ display: "flex", gap: 20, fontSize: 13, marginTop: 20, color: "#4a5568", flexWrap: "wrap", flexDirection: "column" }}>
                      {pickLocalized(f, "duration", lang) && (
                        <span style={{ display: "flex", alignContent: "center", alignItems: "center" }}>
                          {/* <ClockI style={{ marginRight: 6 }} /> */}
                          {t.faculty.duration} : <b> {pickLocalized(f, "duration", lang)}</b>
                        </span>
                      )}
                      {pickLocalized(f, "diploma", lang) && (
                        <span style={{ display: "flex", alignContent: "center", alignItems: "center" }}>
                          {/* <CertI style={{ marginRight: 6 }} /> */}
                          {t.faculty.diploma} : <b> {pickLocalized(f, "diploma", lang)}</b>
                          
                        </span>
                      )}
                    </div>
                    {(() => {
                      const filiereContents = contents.filter((c: any) => c.filiereId === f.id);
                      const publications = filiereContents.filter((c: any) => !isOnlineCourse(c));
                      const courses = filiereContents.filter(isOnlineCourse);
                      if (filiereContents.length === 0) return null;
                      return (
                        <div data-testid={`filiere-resources-${f.slug}`} style={{ marginTop: 16, borderTop: "1px dashed #e1e6ee", paddingTop: 14, display: "grid", gap: 14 }}>
                          {publications.length > 0 && (
                            <div>
                              <div style={{ fontSize: 13, fontWeight: 700, color: Colors.primaryColor, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                                <CertI /> {t.faculty.publications}
                              </div>
                              <ul style={{ margin: 0, paddingLeft: 18, display: "grid", gap: 6 }}>
                                {publications.map((c: any) => (
                                  <li key={c.id}>
                                    <Link to={`${routes.ARTICLESDETAILS}/${c.slug}`} style={{ color: Colors.darkColor, textDecoration: "none", fontSize: 14 }}>
                                      {c.title}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                          {courses.length > 0 && (
                            <div>
                              <div style={{ fontSize: 13, fontWeight: 700, color: Colors.primaryColor, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                                <GradI /> {t.faculty.onlineCourses}
                              </div>
                              <ul style={{ margin: 0, paddingLeft: 18, display: "grid", gap: 6 }}>
                                {courses.map((c: any) => (
                                  <li key={c.id}>
                                    <Link to={`${routes.ARTICLESDETAILS}/${c.slug}`} style={{ color: Colors.darkColor, textDecoration: "none", fontSize: 14 }}>
                                      {c.title}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      );
                    })()}
                  </div>
                ))}
                {(!faculty.filieres || faculty.filieres.length === 0) && (
                  <p style={{ color: "#888" }}>{t.faculty.noPrograms}</p>
                )}
              </div>
            </section>

            {Array.isArray(faculty.specialPrograms) && faculty.specialPrograms.length > 0 && (
              <section style={{ marginTop: 48 }}>
                <PageSectionHeader
                  id="faculty-special-programs"
                  eyebrow={"Programmes"}
                  title={t.faculty.specialPrograms}
                  lead={t.faculty.specialProgramsLead}
                  align="start"
                />
                <div data-testid="special-programs-list" style={{ display: "grid", gap: 14 }}>
                  {faculty.specialPrograms.map((p: any) => {
                    const progContents = (p.contents || []).filter((c: any) => c.status === "published");
                    const events = progContents.filter((c: any) => c.type === "event" || c.type === "activity");
                    const courses = progContents.filter((c: any) => c.type !== "event" && c.type !== "activity");
                    return (
                      <div key={p.id} data-testid={`special-program-${p.slug}`} className="faculty-program-card">
                        <h4 style={{ color: Colors.darkColor, fontSize: 17, marginBottom: 8, display: "flex", alignItems: "center", gap: 10 }}>
                          <GradI color={Colors.primaryColor} />
                          <Link to={`${routes.SPECIAL_PROGRAMS}/${p.slug}`} style={{ color: Colors.darkColor, textDecoration: "none" }}>
                            {pickLocalized(p, "name", lang)}
                          </Link>
                        </h4>
                        {pickLocalized(p, "description", lang) && (
                          <p style={{ color: "#5c6b7a", marginBottom: 12, lineHeight: 1.6 }}>{pickLocalized(p, "description", lang)}</p>
                        )}
                        {progContents.length > 0 && (
                          <div style={{ marginTop: 6, borderTop: "1px dashed #e1e6ee", paddingTop: 14, display: "grid", gap: 14 }}>
                            {events.length > 0 && (
                              <div>
                                <div style={{ fontSize: 13, fontWeight: 700, color: Colors.primaryColor, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                                  <CertI /> {t.faculty.events}
                                </div>
                                <ul style={{ margin: 0, paddingLeft: 18, display: "grid", gap: 6 }}>
                                  {events.map((c: any) => (
                                    <li key={c.id}>
                                      <Link to={`${routes.ARTICLESDETAILS}/${c.slug}`} style={{ color: Colors.darkColor, textDecoration: "none", fontSize: 14 }}>
                                        {c.title}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                            {courses.length > 0 && (
                              <div>
                                <div style={{ fontSize: 13, fontWeight: 700, color: Colors.primaryColor, marginBottom: 8, display: "flex", alignItems: "center", gap: 6 }}>
                                  <GradI /> {t.faculty.courses}
                                </div>
                                <ul style={{ margin: 0, paddingLeft: 18, display: "grid", gap: 6 }}>
                                  {courses.map((c: any) => (
                                    <li key={c.id}>
                                      <Link to={`${routes.ARTICLESDETAILS}/${c.slug}`} style={{ color: Colors.darkColor, textDecoration: "none", fontSize: 14 }}>
                                        {c.title}
                                      </Link>
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        )}
                        <div style={{ marginTop: 14 }}>
                          <Link
                            to={`${routes.SPECIAL_PROGRAMS}/${p.slug}`}
                            style={{ color: Colors.primaryColor, fontWeight: 600, fontSize: 13, textDecoration: "none" }}
                          >
                            {t.specialProgram?.viewDetails || "Voir les détails →"}
                          </Link>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </section>
            )}

            {contents.length > 0 && (
              <section style={{ marginTop: 48 }}>
                <h3 style={{ color: Colors.primaryColor, fontSize: 22, fontWeight: 700, marginBottom: 16 }}>{t.faculty.news}</h3>
                <div style={{ display: "grid", gap: 12 }}>
                  {contents.slice(0, 6).map((c) => (
                    <Link
                      key={c.id}
                      to={`${routes.ARTICLESDETAILS}/${c.slug}`}
                      style={{
                        display: "flex", gap: 16, background: "#fff", padding: 16, borderRadius: 12,
                        textDecoration: "none", color: "inherit", border: "1px solid #e8ecf1",
                      }}
                    >
                      {c.coverImage && (
                        <img src={c.coverImage} alt="" style={{ width: 120, height: 88, objectFit: "cover", borderRadius: 8, flexShrink: 0 }} />
                      )}
                      <div>
                        <div style={{ fontSize: 11, color: Colors.redColor, textTransform: "uppercase", fontWeight: 700 }}>{c.type}</div>
                        <h5 style={{ margin: "6px 0 4px", color: Colors.darkColor, fontSize: 16 }}>{c.title}</h5>
                        <p style={{ fontSize: 13, color: "#666", margin: 0 }}>{(c.excerpt || "").slice(0, 120)}</p>
                      </div>
                    </Link>
                  ))}
                </div>
              </section>
            )}
          </div>

          <aside>
            <div className="faculty-sidebar-card faculty-sidebar-card--primary">
              <h4 style={{ color: "#fff", marginBottom: 16, fontSize: 16, fontWeight: 700 }}>{t.faculty.direction}</h4>
              <div style={{ display: "flex", gap: 12, marginBottom: 18 }}>
                <div>
                  <div style={{ fontSize: 12, opacity: 0.85 }}>{t.faculty.dean}</div>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{dean || "—"}</div>
                </div>
              </div>
              <div style={{ display: "flex", gap: 12 }}>
                <div>
                  <div style={{ fontSize: 12, opacity: 0.85 }}>{t.faculty.secretary}</div>
                  <div style={{ fontWeight: 600, fontSize: 15 }}>{secretary || "—"}</div>
                </div>
              </div>
            </div>
            <div className="faculty-sidebar-card">
              <h5 style={{ color: Colors.primaryColor, fontWeight: 700, marginBottom: 8 }}>{t.faculty.domain}</h5>
              <p style={{ color: "#444", margin: 0 }}>{domaine}</p>
            </div>
            <Link to={routes.FACULTIES} style={{ color: Colors.primaryColor, textDecoration: "none", fontWeight: 600, fontSize: 14 }}>
              ← {t.faculty.allFaculties}
            </Link>
          </aside>
        </div>
      </div>
    </>
  );
};
